import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-assign-lessons-dialog',
  templateUrl: './assign-lessons-dialog.component.html',
  styleUrls: ['./assign-lessons-dialog.component.scss']
})
export class AssignLessonsDialogComponent implements OnInit {
  assignLessonsConfirmed = new EventEmitter<any>();
  title: string;
  todayDate: Date = new Date();

  assignLessonsForm: FormGroup = new FormGroup({
    startDate: new FormControl(new Date(), Validators.required),
    endDate: new FormControl('', Validators.required),
    assignFromOption: new FormControl(0),
    removeExtended: new FormControl(false)
  })

  constructor(
    public dialogRef: MatDialogRef<AssignLessonsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.title = data.title;
  }

  ngOnInit(): void {
    this.assignLessonsForm.controls['startDate'].valueChanges.subscribe(startDate => {
      if(this.assignLessonsForm.controls['endDate'].value !== null) {
        if(this.assignLessonsForm.controls['endDate'].value.getDate() < startDate.getDate()) {
          this.assignLessonsForm.controls['endDate'].setValue(null);
        }
      }
    });
  }

  onAssignConfirm = () => {
      this.assignLessonsConfirmed.emit({
          StartDate: this.assignLessonsForm.controls['startDate'].value,
          EndDate: this.assignLessonsForm.controls['endDate'].value,
          AssignFromOption: this.assignLessonsForm.controls['assignFromOption'].value,
          RemoveExtendedResponseOption: this.assignLessonsForm.controls['removeExtended'].value
      });
      this.dialogRef.close();
  }

  onCancel = () => {
    this.dialogRef.close();
  }

}
